export enum STATUS_EXCHANGE {
  IN_PROGRESS = "IN_PROGRESS",
  WAIT_BANK = "WAIT_BANK",
  OK = "OK",
  HOLD = "HOLD",
  CANCELED = "CANCELED",
  ERROR_ANTIFRAUD = "ERROR_ANTIFRAUD",
  ERROR_BANK = "ERROR_BANK",
  REFUND_REQUESTED = "REFUND_REQUESTED",
  REFUNDED = "REFUNDED",
  ERROR_INIT = "ERROR_INIT",
  TIMEOUT = "TIMEOUT",
}
